import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const dietNeedsApi = createApi({
  reducerPath: 'dietNeeds',
  tagTypes: ['DietNeed'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchDietNeeds: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'DietNeed', id: 'LIST' },
                ...result.map((r) => ({ type: 'DietNeed', id: r.id })),
              ]
            : [{ type: 'DietNeed', id: 'LIST' }],
        query: () => ({
          url: `?resource=diet_needs&order=created_at.asc`,
          method: 'GET',
        }),
      }),

      createDietNeed: builder.mutation({
        invalidatesTags: [{ type: 'DietNeed', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=diet_needs`,
          method: 'POST',
          body: data,
        }),
      }),

      updateDietNeed: builder.mutation({
        invalidatesTags: (result, error, { id: dietNeedId }) => [
          { type: 'DietNeed', id: dietNeedId },
          { type: 'DietNeed', id: 'LIST' },
        ],
        query: ({ id: dietNeedId, submitData }) => ({
          url: `?resource=diet_needs&id=eq.${dietNeedId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchDietNeed: builder.query({
        providesTags: (result, error, arg) => [{ type: 'DietNeed', id: arg }],
        query: (dietNeedId) => ({
          url: `?resource=diet_needs&id=eq.${dietNeedId}`,
          method: 'GET',
        }),
      }),

      fetchDietNeedByUserId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'DietNeed', id: 'LIST' },
                ...result.map((r) => ({ type: 'DietNeed', id: r.id })),
              ]
            : [{ type: 'DietNeed', id: 'LIST' }],
        query: (userId) => ({
          url: `?resource=diet_needs&athlete=eq.${userId}&select=*,diet(*,athlete(*))`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchDietNeedsQuery,
  useCreateDietNeedMutation,
  useUpdateDietNeedMutation,
  useFetchDietNeedQuery,
  useFetchDietNeedByUserIdQuery,
} = dietNeedsApi;

export { dietNeedsApi };
